import React, { useState, useEffect, useRef } from "react";
import Header from "../../../components/header/Header";
import styled from "styled-components";
import Footer from "../../../components/footer/Footer";
import ChatComponent from "./ChatComponent";
import AWS from "aws-sdk";
import StarpilotChat from "../../../components/StarpilotChatTrslnSingleMic";
import TranscriptChat from "../../../components/TranscriptChat";
import moment from "moment";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  useMeetingManager,
  useMeetingStatus,
  useToggleLocalMute,
  useSelectAudioInputDevice,
  useAudioInputs,
  useContentShareState,
  LocalVideo,
  useLocalVideo,
  useRemoteVideoTileState,
  RemoteVideo,
  ContentShare,
  useContentShareControls,
  useFeaturedTileState,
  useSelectVideoQuality,
  useRosterState,
  Roster,
  RosterGroup,
  RosterAttendee,
  useAttendeeStatus,
  useActiveSpeakersState,
} from "amazon-chime-sdk-component-library-react";
import {
  doctorMeeting,
  joinOtherUserApi,
  meetingInfoApi,
  isRxSentForAutoFillPrescription,
  meetingEndPrescriptionListFromChimeConversation,
  getStarPilotMonteChatHistoryTrsln,
  getStarPilotMonteChatTrslnSingleMic,
  getFinalPostralSummary,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import {
  getAwsChimeChatGptResponse,
  getAwsChimeChatGptMessages,
  addChimePromptInConversationSingleMic,
  updateAppoinmentStatus,
  updateAppoinment,
  getDownloadChimeConversationGptResponseTextFile,
} from "../../../api/apiHandler";
import { v4 as uuidv4 } from "uuid";
import queryString from "query-string";
import { InviteListPop } from "../../../modal/InviteListPop/index";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import constant from "../../../constant/constant";
import constantFunc from "../../../constant/constantFunc";
import useInaudiblePopup from "../../../hooks/useInaudiblePopup";
import LatencyModal from "../../../components/footer/Common/LatencyPopup";
import { useSpeechSynthesis } from "react-speech-kit";
// console.log('AWS: ', AWS);

function MeetingRoomSingleMic({
  data,
  handleBookAppointment,
  setPatientName,
  patientName,
  showIsNameModal,
  setShowIsNameModal,
}) {
  const navigate = useNavigate();
  const param = useParams();
  const location = useLocation();
  const [meetingData, setMeetingData] = useState();
  useEffect(() => {
    if (data) {
      setMeetingData(data);
    }
  }, []);
  const { speak, cancel, speaking, supported, voices } = useSpeechSynthesis();
  console.log(data, "mesetssinsgDasta", patientName);
  const meetingManager = useMeetingManager();
  const [chat, setChat] = useState(true);
  const [transcriptChat, setTranscriptChat] = useState(false);
  const [inactive, setInactive] = useState(true);
  const [language, setLanguage] = useState("");
  const [patientLanguage, setPatientLanguage] = useState("");
  const [guest, setGuest] = useState(false);
  const [guestMeetData, setGuestMeetData] = useState("");
  const meetingStatus = useMeetingStatus();
  const { toggleMute } = useToggleLocalMute();
  const [instruction] = useState(constant?.auto_rx_instruction);
  const selectAudioInput = useSelectAudioInputDevice();
  const [audioStatus, setAudioStatus] = useState(true);
  const [videoTiles, setVideoTiles] = useState(false);
  const [callCreated, setCallCreated] = useState(false);
  const [joinBtn, setJoinBtn] = useState(false);
  const fileInputRef = useRef(null);
  const [leaveBtn, setLeaveBtn] = useState(false);
  const [transacriptName, setTransacriptName] = useState("");
  const [meetingResponse, setMeetingResponse] = useState(null);
  const [attendeeResponse, setAttendeeResponse] = useState(null);
  const [activeAttendeeId, setActiveAttendeeId] = useState(null);
  const [screenShareBtn, setScreenShareBtn] = useState(true);
  const [videoBtn, setVideoBtn] = useState(false);
  const [handleScreenShareBtn, setHandleScreenShareBtn] = useState(false);
  const [userEmail, setUserEmail] = useState(data != null ? data?.email : null);

  const [userName, setUserName] = useState(data != null ? data?.name : null);
  const [handleJoinOtherUserApi, setHandleJoinOtherUserApi] = useState(false);
  const [patientId, setPatientId] = useState(
    data != null ? data?.patient_id : 0
  );
  let userRole = localStorage.getItem("user_login_type_role");
  console.log("patientId_userRole ", userRole);
  console.log(
    "ttests===>",
    localStorage.getItem("user_login_type_role", false)
  );
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [me, setMe] = useState();
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();
  const [storedTranscript, setStoredTranscript] = useState([]);
  const [showSuggestionModal, setShowSuggestionModal] = useState(false);
  const [getChatGptResponse, setGetChatGptResponse] = useState(null);
  const [invite, setInvite] = useState(null);
  const [activeChat, setActiveChat] = useState(false);
  const [image, setImage] = useState("");
  const [fileType, setFileType] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);

  const [uuid, setUuid] = useState("");
  const [isNewchat, setIsNewChat] = useState(1);
  const [handleChatGptApiCalling, setHandleChatGptApiCalling] = useState(false);
  // const [handleScreenShareView,setScreenShareView] = useState(true);
  console.log("handleChatGptApiCalling==>", handleChatGptApiCalling);
  const activeSpeakers = useActiveSpeakersState();
  const { roster } = useRosterState();
  const prevRosterRef = useRef({});
  const [activeSpeakerName, setActiveSpeakerName] = useState("");

  const [inputText, setInputText] = useState("");
  const [handleLoader, setHandleLoader] = useState(false);
  const [permissionGranted, setPermissionGranted] = useState(true);
  const [cameraAvailable, setCameraAvailable] = useState(false);
  const [selfAttendeeId, setSelfAttendeeId] = useState(null);
  const [speedKbps, setSpeedKbps] = useState(null);
  const [message, setMessage] = useState("");
  const silenceTimer = useRef(null);

  useEffect(() => {
    const checkNavigatorConnection = () => {
      const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

      if (connection && connection.downlink) {
        const estimatedMbps = connection.downlink; // Mbps
        const estimatedKbps = estimatedMbps * 1024;
        const roundedKbps = Number(estimatedKbps.toFixed(2));

        setSpeedKbps(roundedKbps);
        checkBandwidthStatus(roundedKbps);

        if (estimatedKbps < 1500) {
          setMessage(
            "🚨 Your connection is slow. You may experience degraded video/audio quality."
          );
        } else if (estimatedKbps < 3000) {
          setMessage("⚠️ Connection is okay for SD video.");
        } else {
          setMessage("✅ You have a good internet connection.");
        }

        return true;
      }

      return false;
    };

    const checkDownloadSpeed = async () => {
      const imageUrl =
        "https://upload.wikimedia.org/wikipedia/commons/3/3f/Fronalpstock_big.jpg"; // ~5MB
      const startTime = performance.now();
      const response = await fetch(imageUrl, { cache: "no-store" });
      const endTime = performance.now();

      const blob = await response.blob();
      const duration = (endTime - startTime) / 1000; // seconds
      const bitsLoaded = blob.size * 8;
      const kbps = bitsLoaded / duration / 1024;
      const roundedKbps = Number(kbps.toFixed(2));
      setSpeedKbps(roundedKbps);
      checkBandwidthStatus(roundedKbps);

      if (kbps < 1500) {
        setMessage(
          "🚨 Your connection is slow. You may experience degraded video/audio quality."
        );
      } else if (kbps < 3000) {
        setMessage("⚠️ Connection is okay for SD video.");
      } else {
        setMessage("✅ You have a good internet connection.");
      }
    };

    // First try navigator.connection
    const usedNavigator = checkNavigatorConnection();

    // If not supported, fallback to download test
    if (!usedNavigator) {
      checkDownloadSpeed();
    }
  }, []);

  const checkBandwidthStatus = (speedKbps) => {
    let errorMessage = "";
    let icon = "error";
    console.log(speedKbps, "speedKbpsss");
    // let speedKbps = 650
    if (speedKbps < 650) {
      errorMessage += "🚨 Not sufficient for 1:1 video calling\n";
    } else if (speedKbps < 54) {
      errorMessage += "🚨 Not sufficient for audio calling\n";
    } else if (speedKbps < 1200) {
      errorMessage += "🚨 Not good for high-quality screen sharing\n";
    } else if (speedKbps < 320) {
      errorMessage += "🚨 Not good for low-quality screen sharing\n";
    }
    if (errorMessage) {
      Swal.fire({
        title: "Network Quality is low",
        text: errorMessage,
        icon: icon,
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    const prevRoster = prevRosterRef.current;
    const currentRoster = roster;

    const prevIds = Object.keys(prevRoster);
    const currentIds = Object.keys(currentRoster);

    const joinedIds = currentIds.filter((id) => !prevIds.includes(id));
    const leftIds = prevIds.filter((id) => !currentIds.includes(id));

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });

    joinedIds.forEach((id) => {
      const rawExternalUserId = currentRoster[id]?.externalUserId;
      const name = rawExternalUserId?.split("#")[1] || "Someone";

      if (id === selfAttendeeId) {
        Toast.fire({
          icon: "success",
          title: `You have joined the room`,
        });
      } else {
        Toast.fire({
          icon: "success",
          title: `${
            patientName !== ""
              ? patientName.first_name + " " + patientName.last_name
              : meetingData?.patient_f_fullName
          } has joined the room`,
        });
      }
    });

    leftIds.forEach((id) => {
      const rawExternalUserId = prevRoster[id]?.externalUserId;
      const name = rawExternalUserId?.split("#")[1] || "Someone";

      if (id === selfAttendeeId) {
        Toast.fire({
          icon: "info",
          title: `You have left the room`,
        });
      } else {
        Toast.fire({
          icon: "info",
          title: `${
            patientName !== ""
              ? patientName.first_name + " " + patientName.last_name
              : meetingData?.patient_f_fullName
          } has left the room`,
        });
      }
    });

    prevRosterRef.current = currentRoster;
  }, [roster]);

  const checkPermissions = async () => {
    try {
      const micStatus = await navigator.permissions.query({
        name: "microphone",
      });

      let cameraStatus = { state: "granted" };
      if (cameraAvailable) {
        cameraStatus = await navigator.permissions.query({ name: "camera" });
      }

      if (
        micStatus.state === "granted" &&
        (!cameraAvailable || cameraStatus.state === "granted")
      ) {
        setPermissionGranted(true);
      } else {
        setPermissionGranted(false);
      }
    } catch (error) {
      console.error("Error checking permissions:", error);
      setPermissionGranted(false);
    }
  };

  const requestPermissions = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasCamera = devices.some((device) => device.kind === "videoinput");
      const hasMicrophone = devices.some(
        (device) => device.kind === "audioinput"
      );

      setCameraAvailable(hasCamera);

      if (!hasCamera && !hasMicrophone) {
        console.error("No camera and no microphone available!");
        setPermissionGranted(false);
        return;
      }

      if (hasCamera && hasMicrophone) {
        await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
      } else if (hasCamera && !hasMicrophone) {
        await navigator.mediaDevices.getUserMedia({ video: true });
      } else if (!hasCamera && hasMicrophone) {
        await navigator.mediaDevices.getUserMedia({ audio: true });
      }

      await checkPermissions();
    } catch (error) {
      console.error("Permission denied or error:", error);
      if (error && typeof error === "object") {
        if (error.name === "NotAllowedError") {
          Swal.fire({
            title: "Permission Denied!",
            text: "Please enable microphone (and camera if required) in your browser settings.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          alert("An unexpected error occurred. Please try again.");
        }
      } else if (typeof error === "string") {
        // If the error is a string, just display it directly
        alert(`Error: ${error}`);
      } else {
        alert("An unknown error occurred.");
      }
    }
  };
  console.log(permissionGranted, "permissio12345nGranted");
  useEffect(() => {
    if (!permissionGranted) {
      requestPermissions();
      setAudioStatus(data?.patient_id ? true : false);
      toggleMute(true);
      setActiveChat(data?.patient_id ? true : false);
    }
  }, [permissionGranted, data?.patient_id]);
  useEffect(() => {
    if (data?.patient_id) {
      setActiveChat(data?.patient_id ? true : false);
    }
  }, [data?.patient_id]);

  useEffect(() => {
    const init = async () => {
      await checkPermissions();
    };
    init();
  }, []);

  useEffect(() => {
    return () => {
      // This runs when the component is unmounted due to route change
      meetingManager.leave();
      SpeechRecognition.stopListening();
    };
  }, [location.pathname]);

  useEffect(() => {
    if (activeSpeakers.length > 0 && roster) {
      const activeSpeakerId = activeSpeakers[0];
      const activeSpeakerInfo = roster[activeSpeakerId];
      if (activeSpeakerInfo) {
        // Assuming the name is stored after '#'
        const name = activeSpeakerInfo.externalUserId.split("#")[1];
        setActiveSpeakerName(name);
      } else {
        setActiveSpeakerName("");
      }
    }
  }, [activeSpeakers, roster]);

  useEffect(() => {
    generateUuidIfEmpty();
  }, []);

  const generateUuidIfEmpty = () => {
    if (!uuid) {
      const newUuid = uuidv4();
      setUuid(newUuid);
    }
  };

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const isMobileDevice = /Mobi|Android/i.test(userAgent);

    setScreenShareBtn(!isMobileDevice);
    console.log(data, "datasas2323");

    if (data !== null) {
      if (data?.patient_id) {
        joinOtherUser({ joinInviteBtn: false });
      } else {
        startCall();
      }
    } else {
      joinOtherUser({ joinInviteBtn: true });
    }

    requestAudioPermissions();
  }, [data?.start_meeting]);

  const requestAudioPermissions = () => {
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {})
      .catch((error) => {});
  };

  const startCall = async () => {
    try {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const res = await doctorMeeting({
        user_login_type_role: localStorage.getItem("user_login_type_role"),
        appointment_id: parseInt(data?.appointment_id),
      });
      const response = JSON.parse(res);
      console.log(response, "responsemeetingd");

      Swal.close();
      setMeetingResponse(response?.data?.meetingResponse);
      setAttendeeResponse(response?.data?.attendeeResponse);
      setMe(response?.data?.attendeeResponse?.Attendee?.AttendeeId);
      // setCallCreated(true);
      setJoinBtn(true);
    } catch (error) {
      setJoinBtn(false);
    }
  };

  const joinMeeting = async () => {
    setJoinBtn(false);
    const joinData = {
      meetingInfo: meetingResponse,
      attendeeInfo: attendeeResponse,
    };

    try {
      await meetingManager.join(joinData);
      await meetingManager.start();
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setVideoTiles(true);
      setCallCreated(true);
      setLeaveBtn(true);
      setHandleChatGptApiCalling(true);
      // setVideoTiles(meetingManager.videoTileStates);
    } catch (error) {}
  };
  useEffect(() => {
    if (joinBtn) {
      joinMeeting();
    }
  }, [joinBtn]);

  const joinOtherUser = async (joinUser) => {
    let joinOtherUserObj;
    let res;
    if (joinUser.joinInviteBtn) {
      if (localStorage.getItem("user_token")) {
        if (localStorage.getItem("user_login_type_role") == 1) {
          navigate("/");
        }

        joinOtherUserObj = {
          meeting_id: param.meetingid,
          appointment_id: param.appointmentid,
          user_id: parseInt(localStorage.getItem("user_id")),
          name: localStorage.getItem("user_name"),
          email: localStorage.getItem("user_email"),
          role: localStorage.getItem("user_login_type_role"),
          joinType: "invite",
        };

        const response = JSON.parse(res);
        console.log("response-->", response);
        if (
          response?.data?.meetingData?.doctor_id ==
          parseInt(localStorage.getItem("user_id"))
        ) {
          const joinMeetingObj = {
            meeting_id: data?.meeting_id,
            appointment_id: data?.appointment_id,
            user_id: localStorage.getItem("user_id"),
            name: localStorage.getItem("user_name"),
            email: localStorage.getItem("user_email"),
            role: parseInt(localStorage.getItem("user_login_type_role")),
            start_meeting: 0,
            patient_id: data?.patient_id,
          };
          console.log("joinMeetingObj", joinMeetingObj);
          navigate("/meeting", { state: joinMeetingObj });
        }
        setGuestMeetData({
          patientId: response?.data?.meetingData?.patient_id,
        });
        // setUserRole(localStorage.getItem("user_login_type_role"));
        setGuest(true);
      } else {
        handleNameInput();
        return;
      }
    } else {
      joinOtherUserObj = {
        meeting_id: data?.meeting_id,
        appointment_id: data?.appointment_id,
        user_id: data?.user_id,
        name: data?.name,
        email: data?.email,
        role: data?.role,
      };
      if (data?.language) {
        joinOtherUserObj.language = data?.language;
      }
    }
    res = await joinOtherUserApi(joinOtherUserObj);

    const response = JSON.parse(res);
    setLanguage(response?.data?.language || "");
    const joinData = {
      meetingInfo: response.data.meetingResponse,
      attendeeInfo: response.data.attendeeResponse,
    };

    setTransacriptName(response.data.transacript_name);
    setMeetingResponse(response.data.meetingResponse);
    setMe(response.data.attendeeResponse.Attendee.AttendeeId);
    try {
      await meetingManager.join(joinData);
      await meetingManager.start();
      SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      setVideoTiles(true);
      setJoinBtn(false);
      setLeaveBtn(true);
      setCallCreated(true);
      chatCreateMonteChatCompletion(true);
    } catch (error) {
      console.log(error, "error");
    }
    // }
  };
  console.log("transacriptName000>", transacriptName);
  const handleNameInput = () => {
    const name = prompt("Enter your name:");
    if (name === null) return;

    const namePattern = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/;

    if (!namePattern.test(name)) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please enter a valid name",
        toast: true,
        showConfirmButton: false,
        timer: 1000,
      }).then(() => {
        handleNameInput();
      });
    } else {
      setUserName(name);
      setTimeout(() => {
        handleEmailInput();
      }, 500);
    }
  };

  const handleEmailInput = () => {
    const email = prompt("Enter your email:");
    if (email === null) return;

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please enter a valid email address",
        toast: true,
        showConfirmButton: false,
        timer: 1000,
      }).then(() => {
        handleEmailInput();
      });
    } else {
      setHandleJoinOtherUserApi(true);
      setUserEmail(email);
    }
  };

  useEffect(() => {
    console.log("get");
    if (userName != null && userEmail != null) {
      if (handleJoinOtherUserApi) {
        joinOtherUserViaInvite();
      }
    }
  }, [handleJoinOtherUserApi]);

  const joinOtherUserViaInvite = async () => {
    const joinOtherUserObj = {
      meeting_id: param.meetingid,
      appointment_id: 0,
      user_id: 0,
      name: userName,
      email: userEmail,
      role: 4,
    };

    if (userName && userEmail) {
      const res = await joinOtherUserApi(joinOtherUserObj);

      const response = JSON.parse(res);
      const joinData = {
        meetingInfo: response.data.meetingResponse,
        attendeeInfo: response.data.attendeeResponse,
      };
      setMeetingResponse(response.data.meetingResponse);
      setMe(response.data.attendeeResponse.Attendee.AttendeeId);
      setHandleJoinOtherUserApi(false);
      try {
        await meetingManager.join(joinData);
        await meetingManager.start();
        SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
        setVideoTiles(true);
        setJoinBtn(false);
        setLeaveBtn(true);
        setCallCreated(true);
        // setVideoTiles(meetingManager.videoTileStates);
      } catch (error) {}
    }
  };

  const handleAudio = async () => {
    if (permissionGranted) {
      setAudioStatus(!audioStatus);
      if (!audioStatus) {
        SpeechRecognition.startListening({ continuous: true, timeout: 5000 });
      } else {
        SpeechRecognition.stopListening();
      }
      if (!audioStatus) {
        // Unmute and select default audio input
        toggleMute(false);
        selectAudioInput("default");
      } else {
        toggleMute(true);
        selectAudioInput(null);
      }
    } else {
      requestPermissions();
    }
  };

  const handleOtherUserJoin = async () => {
    try {
      // Use the Clipboard API to copy text to the clipboard
      if (!guest && localStorage.getItem("user_login_type_role") == 2) {
        let url =
          process.env.REACT_APP_WEB_URL +
          "meeting-single-mic/" +
          parseInt(data?.appointment_id) +
          "/" +
          meetingResponse.Meeting.MeetingId;
        await navigator.clipboard.writeText(url);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Link copied",
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (activeSpeakers.length > 0 && roster) {
      const activeSpeakerId = activeSpeakers[0];
      const activeSpeakerInfo = roster[activeSpeakerId];
      if (activeSpeakerInfo) {
        // Assuming the name is stored after '#'
        const name = activeSpeakerInfo.externalUserId.split("#")[1];
        setActiveSpeakerName(name);
      } else {
        setActiveSpeakerName("");
      }
    }
  }, [activeSpeakers, roster]);

  const { toggleVideo } = useLocalVideo();
  const { toggleContentShare } = useContentShareControls();
  const { tileId } = useFeaturedTileState();
  const { tiles, attendeeIdToTileId, tileIdToAttendeeId } =
    useRemoteVideoTileState();

  const { isLocalUserSharing, sharingAttendeeId } = useContentShareState();
  console.log("isLocalUserSharing: ", isLocalUserSharing, sharingAttendeeId);
  const selectVideoQuality = useSelectVideoQuality();
  const attendees = Object.values(roster);

  const localVid = document.getElementById("localvideo");
  const remoteVid = document.getElementById(`remote_${tileId}`);
  if (localVid) {
    if (tileId === null) {
      localVid.classList.add("localvideo_main");
      localVid.classList.remove("localvideo_side");
    } else {
      localVid.classList.add("localvideo_side");
      localVid.classList.remove("localvideo_main");
    }
  }
  if (remoteVid) {
    if (tileId === null) {
      remoteVid.classList.add("remotevideo");
      remoteVid.classList.remove("ch-featured-tile");
    } else {
      remoteVid.classList.remove("remotevideo");
      remoteVid.classList.add("ch-featured-tile");
    }
  }

  const buttonClick = () => {
    setVideoBtn(!videoBtn);
    toggleVideo();
    selectVideoQuality("720p");
  };

  const handleScreenShare = () => {
    toggleContentShare();
    setHandleScreenShareBtn(!handleScreenShareBtn);
    // setScreenShareView(!handleScreenShareView)
  };

  const remoteTiles = Object.entries(attendeeIdToTileId).map((e) => ({
    [e[0]]: e[1],
  }));

  const MyRosterCell = ({ name, attendeeId }) => {
    const { videoEnabled, sharingContent, muted } =
      useAttendeeStatus(attendeeId);
    // console.log(handleScreenShareBtn, "perryParwinder")
    return (
      <>
        {!videoEnabled ? (
          <div
            className={`${
              sharingAttendeeId && "col-lg-3 col-xl-2 col-6"
            } col-md-6 `}
          >
            <div className="member-image bg-dark ">
              <div className="blank-screen " style={{ aspectRatio: 1 }}>
                {name}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const attendeeItems = attendees.map((attendee) => {
    const { chimeAttendeeId, externalUserId } = attendee;
    console.log(attendee, "attendeeasdad");

    const name = externalUserId.split("#")[1];

    remoteTiles.length > 0 &&
      remoteTiles.map((r) => {
        if (r[chimeAttendeeId]) {
          // tempAttendeeInfo.push({"name" : name})
        }
      });
    return (
      <MyRosterCell
        key={chimeAttendeeId}
        attendeeId={chimeAttendeeId}
        name={name}
      />
    );
  });

  console.log(param, "singlemic2222meetingData");

  const autoPresc = async (type) => {
    try {
      let meetingDataObj;
      if (guest) {
        meetingDataObj = {
          meeting_id: param.meetingid,
          appointment_id: param.appointmentid,
          patient_id: patientName.id ? patientName.id : meetingData?.patient_id,
          check: true,
          prescriptionType: type,
        };
      } else {
        meetingDataObj = {
          meeting_id: meetingResponse?.Meeting?.MeetingId,
          appointment_id: data?.appointment_id
            ? data?.appointment_id
            : meetingData?.appointment_id,
          patient_id: patientName.id ? patientName.id : meetingData?.patient_id,
          check: true,
          prescriptionType: type,
        };
      }
      setActiveChat(false);
      const serializedObject = queryString.stringify(meetingDataObj);
      console.log(serializedObject, "serializedObject3323211");

      let url;
      if (userRole == "4") {
        url = `/priest/auto-prescription?${serializedObject}`;
        cancel();
      } else {
        url = `/doctor/auto-prescription?${serializedObject}`;
      }
      setTimeout(() => {
        window.open(url, "_blank");
      }, 500);
    } catch (error) {
      console.log("meetingDataObj---?", error);
    }
  };

  const givePrescriptionWhileLeaving = async (id) => {
    if (id) {
      const findPrescriptionObj = {
        meeting_id: id,
      };
      meetingEndPrescriptionListFromChimeConversation(findPrescriptionObj)
        .then((response) => {
          response = JSON.parse(response);
          if (response.code == process.env.REACT_APP_SUCCESS) {
            console.log("response.data.response-->", response.data.response);
          }
        })
        .catch(() => {
          // Silent fail: no error shown
        });
    }
  };
  let getFinalPostralSummart = async () => {
    cancel();
    await getFinalPostralSummary({
      meeting_id: meetingResponse?.Meeting?.MeetingId,
    });
  };
  const leaveMeeting = async () => {
    try {
      console.log(guest, "guest1234444");

      if (guest === true) {
        // Guest flow
        Swal.fire({
          icon: "warning",
          title: "Exit Meeting",
          text: "Are you sure you want to exit the meeting?",
          showCancelButton: true,
          confirmButtonText: "Yes, Exit",
          cancelButtonText: "Cancel",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await meetingManager.leave();
            SpeechRecognition.stopListening();
            setTimeout(() => navigate("/"), 500);
          }
        });
      } else if (userRole === "2" || userRole === "4") {
        // Doctor flow
        Swal.fire({
          icon: "warning",
          title: "Exit Meeting",
          text: "Are you sure you want to exit the meeting?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Yes",
          denyButtonText: `${
            userRole === "4" ? "Pastoral Summary" : "Auto Prescription"
          } `,
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap",
            confirmButton: "order-2",
            denyButton: "order-3",
          },
        }).then(async (result) => {
          if (result.isConfirmed) {
            const isAutoPrescriptionCompletedObj = {
              meeting_id: meetingResponse?.Meeting?.MeetingId,
            };
            await isRxCompletedOrNot(isAutoPrescriptionCompletedObj);
            await givePrescriptionWhileLeaving(
              meetingResponse?.Meeting?.MeetingId
            );
            if (userRole == "4") {
              getFinalPostralSummart();
              cancel();
            }
            await meetingManager.leave();
            SpeechRecognition.stopListening();
          } else if (result.isDenied) {
            Swal.fire({
              title: `Do you want to continue with ${
                userRole == "4" ? "Pastoral Summary?" : "Auto Prescription?"
              }`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
            }).then(async (res) => {
              if (res.isConfirmed) {
                const meetingDataObj = {
                  meeting_id: meetingResponse?.Meeting?.MeetingId,
                  appointment_id: data?.appointment_id,
                  patient_id: patientName?.id,
                  prescriptionType: "final_pres",
                };
                // if (userRole == "4") {
                //   getFinalPostralSummart();
                // }
                setActiveChat(false);
                const serializedObject = queryString.stringify(meetingDataObj);
                let url;
                if (userRole == "4") {
                  url = `/priest/auto-prescription?${serializedObject}`;
                  getFinalPostralSummart();
                  cancel();
                } else {
                  url = `/doctor/auto-prescription?${serializedObject}`;
                }
                setTimeout(() => {
                  window.open(url, "_blank");
                  meetingManager.leave();
                  SpeechRecognition.stopListening();
                }, 500);
              } else {
                await handleMeetingStatus();
              }
            });
          }
        });
      } else {
        // Patient flow
        Swal.fire({
          icon: "warning",
          title: "Exit Meeting",
          text: "Are you sure you want to exit the meeting?",
          showCancelButton: true,
          confirmButtonText: "Yes, Exit",
          cancelButtonText: "Cancel",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await handlePatientMeetingStatus();
            if (userRole == "4") {
              getFinalPostralSummart();
            }
          }
        });
      }
    } catch (error) {
      console.error("Error leaving meeting:", error);
    }
  };

  const isRxCompletedOrNot = (isAutoPrescriptionCompletedObj) => {
    isRxSentForAutoFillPrescription(isAutoPrescriptionCompletedObj).then(
      async (response) => {
        response = JSON.parse(response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          if (response.data.is_rx_sent == 1) {
            await meetingManager.leave();
            SpeechRecognition.stopListening();
            setTimeout(() => {
              navigate("/");
            }, 500);
          } else {
            handleMeetingStatus();
          }
        } else if (response.code == process.env.REACT_APP_ERROR) {
          handleMeetingStatus();
        } else {
          handleMeetingStatus();
        }
      }
    );
  };

  const handleMeetingStatus = () => {
    const updateStatusObj = {
      appointment_id: data?.appointment_id,
      appointment_status: process.env.REACT_APP_MEETING_DONE,
    };

    updateAppoinmentStatus(updateStatusObj).then(async (response) => {
      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        await meetingManager.leave();
        SpeechRecognition.stopListening();
        setTimeout(() => {
          if (userRole == "4") {
            navigate("/priest/home");
          } else {
            navigate("/doctor/home");
          }
        }, 500);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  const handlePatientMeetingStatus = () => {
    console.log("handleLeave");
    const updateStatusObj = {
      appointment_id: data?.appointment_id,
    };
    updateAppoinment(updateStatusObj).then(async (response) => {
      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        await meetingManager.leave();
        SpeechRecognition.stopListening();
        setTimeout(() => {
          navigate("/");
        }, 500);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  const add_montechat_transcript = async (data) => {
    try {
      const meetingId = data?.meeting_id
        ? data?.meeting_id
        : meetingResponse?.Meeting?.MeetingId;
      const patientId = patientName?.id || data?.patient_id;
      const loginRole = userRole;

      let role = "Guest";
      if (guest && userRole === "2" && transacriptName) {
        role = transacriptName;
      } else if (userRole === "2") {
        role = "Doctor1";
      } else if (userRole === "1") {
        role = "Patient";
      } else if (userRole === "3") {
        role = "Chemist";
      } else if (userRole === "4") {
        role = "Priest";
      }

      const activeUserObj = {
        meeting_id: meetingId,
        patient_id: patientId,
        role,
        transcript: data,
        login_role: loginRole,
      };
      return addChimePromptInConversationSingleMic(activeUserObj).then(
        (response) => {
          response = JSON.parse(response);
          setLoadingChat(true);
          if (response.code == process.env.REACT_APP_SUCCESS) {
            // console.log("response.data==>", response.data)
            console.log(response, "some_resomsss");

            setStoredTranscript(response.data);
            handleChatPolling();
            return response.data;
          } else {
            return false;
          }
        }
      );
    } catch (error) {
      console.log("error---->", error);
    }
  };
  console.log(patientName, "patiens12tName");
  const [conversation, setConversation] = useState([]);
  const [loadingChat, setLoadingChat] = useState(false);
  const [audible, setAudible] = useState(true);
  const [speakingText, setSpeakingText] = useState(null);
  const [translatedText, setTranslatedText] = useState(null);
  const chatCreateMonteChatCompletion = async (status) => {
    try {
      cancel();
      const res = await getStarPilotMonteChatTrslnSingleMic({
        meeting_id: data?.meeting_id
          ? data?.meeting_id
          : meetingResponse?.Meeting?.MeetingId,
        transcript_name: transacriptName,
        rejoin: status,
        // languageCode: language,
      });

      const response = JSON.parse(res);

      console.log(response, "resppon33213ceessss");
      if (response.code === 200) {
        setIsNewChat(0);

        const newMsgT = await constantFunc.convertMarkdownLinksToHTML(
          response.data.response
        );
        if (userRole === "4") {
          const firstResponse = response?.data?.response;
          let translatedMsg = response.data.translatedMsg;

          // if (firstResponse) speak({ text: firstResponse });

          setSpeakingText(firstResponse);
          setTranslatedText(translatedMsg);
        }
        if (
          Array.isArray(response.data.chatHistory) &&
          response.data.chatHistory.length > 0
        ) {
          setConversation(response.data.chatHistory);
        } else {
          setConversation([newMsgT]);
        }

        setAudible(true);

        // setSearchValue("");
        // reset();
        console.log("responseData-->", response);
      }
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Something went wrong",
        text: error?.message || "Unexpected error occurred.",
        toast: true,
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      setLoadingChat(false);
    }
  };

  const handleChatPolling = async () => {
    const role = parseInt(localStorage.getItem("user_login_type_role"));

    if (role === 2 || role === 4) {
      await chatCreateMonteChatCompletion(false);
    }
  };

  useEffect(() => {
    if (userRole !== "3") {
      const timeout = setTimeout(() => {
        console.log("Not chemist");

        const meetingId = data?.meeting_id
          ? data?.meeting_id
          : meetingResponse?.Meeting?.MeetingId;
        const patientId = patientName?.id || data?.patient_id;
        const loginRole = userRole;

        let role = "Guest";
        if (guest && userRole === "2" && transacriptName) {
          role = transacriptName;
        } else if (userRole === "2") {
          role = "Doctor1";
        } else if (userRole === "1") {
          role = "Patient";
        } else if (userRole === "3") {
          role = "Chemist";
        } else if (userRole === "4") {
          role = "Priest";
        }

        const activeUserObj = {
          meeting_id: meetingId,
          patient_id: patientId,
          role,
          transcript,
          login_role: loginRole,
        };

        console.log("activeUserObj1235", activeUserObj);

        const shouldSubmit = activeChat && transcript;

        if (shouldSubmit) {
          resetTranscript();

          addChimePromptInConversationSingleMic(activeUserObj)
            .then((res) => {
              const response = JSON.parse(res);
              setLoadingChat(true);
              // resetSilenceTimer();

              if (response.code == process.env.REACT_APP_SUCCESS) {
                setStoredTranscript(response.data);
                handleChatPolling();
              } else {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: response.message,
                  toast: true,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
            })
            .catch((error) => {
              resetTranscript();
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: error.message,
                toast: true,
                showConfirmButton: false,
                timer: 2000,
              });
              console.error("error", error);
            });
        }
      }, 10000);

      return () => clearTimeout(timeout);
    } else {
      console.log("It is chemist");
    }
  }, [transcript, data]);

  const handleChatGptApiCall = async () => {
    if (!handleChatGptApiCalling && inputText == "") {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    const chatGptObj = {
      patient_id: patientId,
      meeting_id: meetingResponse?.Meeting?.MeetingId,
      uuid: uuid,
      is_new_chat: isNewchat,
      prompt: storedTranscript.length > 0 ? storedTranscript : "Hello",
    };
    if (uploadImage) {
      console.log("data: ");
      let imgUrl = "";
      await uploadData(uploadImage, "/analysis_file")
        .then((newImage) => {
          Swal.close();
          console.log("newImagenewImagenewImage", newImage);
          imgUrl = newImage;
        })
        .catch((e) => {
          Swal.close();
        });
      chatGptObj.imgUrl = `https://msh-dev.s3.amazonaws.com/analysis_file/${imgUrl}`;
      chatGptObj.imgType = fileType;
    }
    console.log("chatGptObj: getAwsChimeChatGptResponse ", chatGptObj);
    setImage("");
    setUploadImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the input field
    }
    setFileType("");
    getAwsChimeChatGptResponse(chatGptObj).then((response) => {
      response = JSON.parse(response);
      console.log("response gpt response", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setInputText("");
        setHandleLoader(false);
        setGetChatGptResponse(null);
        if (!handleChatGptApiCalling) {
          openSuggestionModal();
        }
        setIsNewChat(0);
        setHandleChatGptApiCalling(false);
        const chatgptResponse = response.data.response;
        // console.log('chatgptResponse: ', chatgptResponse);
        chatgptResponse.forEach((item) => {
          if (item.role == "assistant") {
            setGetChatGptResponse(item.content);
          }
        });
      } else {
        setGetChatGptResponse(null);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      Swal.close();
    });
  };

  const uploadData = async (file, folder_type) => {
    const S3_BUCKET = process.env.REACT_APP_AWS_S3_NAME;
    const REGION = process.env.REACT_APP_AWS_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
      region: REGION,
    });
    const ext = file.name.split(".").pop();
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    try {
      const newFileName = new Date().getTime() + "." + ext;
      const params = {
        Bucket: S3_BUCKET + folder_type,
        Key: newFileName,
        Body: file,
        ACL: "public-read",
      };
      return new Promise((resolve, reject) => {
        s3.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(newFileName);
          }
        });
      });
    } catch (error) {
      console.error("Error in UploadData:", error);
    }
  };

  const onImageChange = (event) => {
    console.log("event00<", event);
    if (event.target.files && event.target.files[0]) {
      console.log("event.target.files[0]==>", event.target.files[0]);
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (allowedTypes.includes(event.target.files[0].type)) {
        const fileSizeLimit = 10 * 1024 * 1024;
        if (event.target.files[0].size > fileSizeLimit) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: "File size exceeds the limit of 10 MB",
            toast: true,
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
          setImage(URL.createObjectURL(event.target.files[0]));
          setUploadImage(event.target.files[0]);
          if (event.target.files[0].type == "application/pdf") {
            setFileType("pdf");
          } else if (event.target.files[0].type == "text/plain") {
            setFileType("text");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ) {
            setFileType("doc");
          } else if (
            event.target.files[0].type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            setFileType("xlsx");
          } else {
            setFileType("image");
          }
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title:
            "Only Image File(png, jpeg, jpg, PDF, Text, docx, xlsx) Type Allowed!",
          toast: true,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }
  };

  const openSuggestionModal = () => {
    setShowSuggestionModal(true);
  };

  const closeSuggestionModal = () => {
    setShowSuggestionModal(false);
    setImage("");
    setUploadImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the input field
    }
    setFileType("");
  };

  const handleSendMessage = async () => {
    if (inputText != "") {
      const userInputObj = {
        role: userRole == "2" ? "Doctor" : "Priest",
        transcript: inputText,
      };
      setStoredTranscript((prevTranscripts) => [
        ...prevTranscripts,
        userInputObj,
      ]);
      setHandleLoader(true);
    }
  };

  useEffect(() => {
    if (handleLoader) {
      handleChatGptApiCall();
    }
  }, [handleLoader]);

  const handleDownloadTxtFile = () => {
    const downloadTxtFileObj = {
      meeting_id: meetingResponse.Meeting.MeetingId,
    };

    getDownloadChimeConversationGptResponseTextFile(downloadTxtFileObj).then(
      (response) => {
        response = JSON.parse(response);
        console.log("response: ", response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          window.open(response.data.url, "_blank");
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: response.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    );
  };

  console.log(
    activeChat,
    loadingChat,
    silenceTimer,
    "meetingStatusCheck",
    audioStatus,
    transcript
  );

  console.log(meetingData, "meetingData388544fdsss433");

  let { countdown, setShowPopup, showPopup, startSilenceDetection } =
    useInaudiblePopup({
      audioStatus,
      activeChat,
      loadingChat,
      silenceTimer,
      transcript,
    });
  // setActiveChat
  // setLoadingChat
  return (
    <>
      {showPopup && (
        <LatencyModal
          show={showPopup}
          onHide={setShowPopup}
          countdown={countdown}
        />
      )}

      {meetingResponse?.Meeting?.MeetingId && (
        <InviteListPop
          meeting_id={
            meetingData?.meeting_id
              ? meetingData?.meeting_id
              : param.meetingid
              ? param.meetingid
              : meetingResponse?.Meeting?.MeetingId
          }
          appointment_id={
            meetingData?.appointment_id
              ? meetingData?.appointment_id
              : param.appointmentid
          }
          invite={invite}
          meetType={"singleMic"}
          setInvite={setInvite}
        />
      )}
      <main className="flex-column">
        <Header />
        <main>
          <section>
            <div className="container">
              <div
                className="meeting-room p-0 mb-0 mx-0"
                style={{
                  borderTopLeftRadius: 20,
                  borderTopRightRadius: 20,
                }}
              >
                <div
                  className="top d-flex align-items-center justify-content-center p-3 position-relative"
                  style={{
                    background: "#216fc8",
                    borderTopLeftRadius: 20,
                    borderTopRightRadius: 20,
                  }}
                >
                  <button
                    className=" rounded rounded-bottom-0  fw-bold px-3  py-1  position-absolute  bottom-0 end-0"
                    onClick={() => setShowIsNameModal(true)}
                  >
                    Search Patient
                  </button>
                  <LabelTag
                    className="position-absolute fw-bold px-3 text-white py-1 "
                    style={{
                      background: "#ff8115",
                      borderTopLeftRadius: "5px",
                      borderBottomLeftRadius: "5px",
                    }}
                  >
                    1-Mic
                  </LabelTag>
                  <div
                    className="flex-shrink-0 imgWrp me-3 d-flex align-items-center                                        justify-content-center bg-white rounded-circle"
                    style={{ height: 100, width: 100 }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_26_398)">
                        <path
                          d="M37.1771 17.2987C38.257 17.141 39.3183 16.9652 40.3858 16.8348C43.7624 16.419 47.165 16.2427 50.5673 16.3071C54.1396 16.384 57.7014 16.7185 61.2239 17.3078C61.5478 17.3624 61.5324 17.5353 61.5324 17.7566C61.5046 19.3486 61.4799 20.9406 61.4398 22.5296C61.4263 22.6546 61.4458 22.7809 61.4966 22.8962C61.5475 23.0115 61.6278 23.1119 61.7298 23.1876C66.5028 27.1116 68.9926 32.1575 69.008 38.2495C69.0761 42.8613 67.4458 47.3418 64.4174 50.8652C61.3891 54.3885 57.167 56.7172 52.5293 57.4218C47.8917 58.1265 43.1512 57.1597 39.1817 54.6996C35.2123 52.2395 32.2814 48.452 30.9294 44.0353C28.8592 37.1973 30.2599 30.9961 34.8632 25.5074C35.4706 24.8301 36.1208 24.191 36.81 23.594C36.9034 23.519 36.9781 23.424 37.0284 23.3162C37.0787 23.2085 37.1032 23.0908 37.1 22.9723C37.1 21.3106 37.1278 19.6367 37.1463 17.9841C37.1494 17.7748 37.1648 17.5595 37.1771 17.2987ZM36.125 29.2282C32.0093 34.7411 31.9044 44.2506 38.7074 50.3033C40.2843 51.705 42.1289 52.7846 44.134 53.4795C46.1391 54.1744 48.2648 54.4706 50.3874 54.351C52.51 54.2313 54.5873 53.6982 56.4984 52.7826C58.4096 51.867 60.1165 50.5872 61.52 49.0176C67.3821 42.5798 66.4565 33.5524 62.3808 28.652C61.6797 29.351 60.9424 30.0139 60.1718 30.6382C58.0553 32.1938 55.5747 32.7609 53.0016 32.9914C50.4296 33.1951 47.8426 33.1168 45.2883 32.7579L44.6219 32.6669C44.7178 32.5906 44.833 32.5414 44.9551 32.5244C46.4577 32.1271 47.9787 31.7814 49.4627 31.3114C50.4766 31.0153 51.3916 30.4584 52.113 29.6982C52.3789 29.366 52.6231 29.0176 52.8442 28.655C52.6128 28.6823 52.5357 28.6884 52.474 28.7005C51.1905 28.9643 49.9101 29.2585 48.6205 29.4859C45.8992 29.962 43.1533 30.244 40.392 29.9529C38.9728 29.8104 37.5813 29.4799 36.125 29.2282Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M37.3635 57.0746C41.144 67.2776 44.9142 77.4523 48.6741 87.5986L48.6093 87.6441C48.5353 87.5592 48.452 87.4804 48.3841 87.3894L33.1582 67.5485C32.6553 66.8965 32.1462 66.2506 31.6619 65.5865C31.6208 65.5219 31.596 65.4485 31.5896 65.3726C31.5831 65.2966 31.5952 65.2203 31.6248 65.1498C33.476 62.4783 35.3704 59.8189 37.2462 57.1565C37.2821 57.125 37.3214 57.0975 37.3635 57.0746Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M61.8267 57.02C62.2926 57.672 62.7091 58.2542 63.1225 58.8395C64.5634 60.8894 65.9949 62.9483 67.4419 64.9891C67.4898 65.0396 67.5269 65.0989 67.5512 65.1636C67.5754 65.2284 67.5863 65.2972 67.5831 65.3661C67.5799 65.435 67.5628 65.5026 67.5328 65.5649C67.5027 65.6272 67.4603 65.683 67.408 65.7291C64.4873 69.5216 61.5706 73.3181 58.6581 77.1187L50.7536 87.4137C50.7237 87.4593 50.6848 87.4986 50.6392 87.5293C50.5937 87.5601 50.5424 87.5816 50.4883 87.5926C54.2647 77.428 58.0318 67.2665 61.8267 57.02Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M61.3261 16.1979C53.4149 14.9432 45.352 14.9207 37.4336 16.1312C37.4067 16.0481 37.3871 15.9629 37.375 15.8765C37.375 14.988 37.375 14.1025 37.375 13.1473C38.1772 13.0503 38.9979 12.9411 39.8186 12.8441C44.9249 12.2944 50.0709 12.1929 55.1956 12.5408C57.1147 12.6712 59.0245 12.9199 60.9404 13.1018C61.249 13.1321 61.3415 13.2322 61.3353 13.5294C61.3137 14.3997 61.3261 15.2669 61.3261 16.1979Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M50.9035 69.662C50.8919 70.031 50.7378 70.3819 50.4724 70.6432C50.2071 70.9046 49.8504 71.0568 49.475 71.069C49.0985 71.0564 48.7417 70.9003 48.4803 70.6337C48.2189 70.3671 48.0732 70.011 48.0743 69.6407C48.073 69.4578 48.1089 69.2764 48.18 69.1073C48.251 68.9382 48.3557 68.7847 48.4879 68.6559C48.6201 68.5271 48.7772 68.4256 48.9498 68.3572C49.1225 68.2889 49.3074 68.2551 49.4935 68.258C49.8696 68.2612 50.2292 68.4107 50.4934 68.6738C50.7577 68.937 50.9051 69.2923 50.9035 69.662Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M50.9355 75.1598C50.9447 75.5296 50.805 75.8881 50.5467 76.1572C50.2885 76.4264 49.9326 76.5845 49.5564 76.5972C49.1813 76.5935 48.822 76.4476 48.5536 76.19C48.2852 75.9324 48.1283 75.5829 48.1156 75.2144C48.1073 74.8449 48.2485 74.4873 48.5083 74.2201C48.768 73.9529 49.125 73.7979 49.5009 73.7892C49.687 73.7851 49.8721 73.8175 50.0454 73.8845C50.2187 73.9515 50.3767 74.0516 50.5102 74.1792C50.6437 74.3068 50.7501 74.4592 50.8231 74.6275C50.8961 74.7959 50.9344 74.9768 50.9355 75.1598Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M49.4979 62.5086C49.6859 62.5106 49.8716 62.549 50.0445 62.6215C50.2174 62.6941 50.3741 62.7994 50.5056 62.9315C50.6371 63.0635 50.7409 63.2197 50.8109 63.3912C50.881 63.5627 50.916 63.746 50.914 63.9308C50.912 64.1156 50.8729 64.2982 50.7991 64.4681C50.7253 64.6381 50.6182 64.7921 50.4838 64.9213C50.3494 65.0505 50.1905 65.1525 50.016 65.2214C49.8416 65.2903 49.655 65.3247 49.467 65.3227C49.0873 65.3187 48.7248 65.1666 48.4593 64.8999C48.1937 64.6331 48.0468 64.2737 48.0509 63.9005C48.055 63.5273 48.2097 63.171 48.4811 62.91C48.7524 62.649 49.1182 62.5046 49.4979 62.5086Z"
                          fill="#216fc8"
                        ></path>
                        <path
                          d="M36.125 29.2282C37.5812 29.4829 38.9727 29.8104 40.3827 29.959C43.1594 30.2622 45.8899 29.959 48.6111 29.492C49.9008 29.2646 51.1812 28.9704 52.4647 28.7066C52.5325 28.7066 52.6035 28.6884 52.8349 28.6611C52.6138 29.0237 52.3696 29.3721 52.1037 29.7043C51.3823 30.4645 50.4673 31.0214 49.4534 31.3175C47.9694 31.7814 46.4484 32.1271 44.9458 32.5304C44.8237 32.5474 44.7085 32.5967 44.6126 32.673L45.279 32.7639C47.8333 33.1228 50.4203 33.2011 52.9923 32.9974C55.5654 32.7609 58.046 32.1999 60.1625 30.6443C60.9331 30.02 61.6704 29.357 62.3715 28.6581C66.4472 33.5554 67.3697 42.5859 61.5107 49.0236C60.1072 50.5933 58.4003 51.8731 56.4891 52.7887C54.578 53.7043 52.5007 54.2374 50.3781 54.357C48.2555 54.4767 46.1298 54.1804 44.1247 53.4856C42.1196 52.7907 40.275 51.711 38.6981 50.3094C31.9043 44.2506 32.0092 34.7411 36.125 29.2282ZM58.1231 47.5832C58.0521 47.559 58.0367 47.5469 58.0244 47.5499C57.9565 47.5711 57.8855 47.5893 57.8176 47.6166C57.1244 47.908 56.3722 48.0384 55.6194 47.9979C54.8666 47.9575 54.1334 47.7471 53.4766 47.3831C52.7362 46.9859 52.0235 46.5431 51.2861 46.1338C51.0187 45.9534 50.7125 45.836 50.3915 45.7908C50.0705 45.7456 49.7431 45.7737 49.4349 45.873C49.3259 45.9092 49.2077 45.9092 49.0986 45.873C48.85 45.7849 48.5848 45.7513 48.3216 45.7743C48.0583 45.7974 47.8034 45.8766 47.5745 46.0064C46.8865 46.3733 46.217 46.7797 45.5413 47.1769C44.0233 48.0624 42.456 48.2928 40.7714 47.6287C40.6807 47.5981 40.5879 47.5738 40.4938 47.5559C41.4348 48.3561 42.5171 48.98 43.687 49.3966C45.1248 49.8818 46.5471 49.9152 47.9293 49.2298C48.4075 48.9933 48.8549 48.681 49.3023 48.399C49.3133 48.3953 49.3252 48.3953 49.3362 48.399C49.4658 48.493 49.5923 48.59 49.7219 48.681C50.3047 49.1278 50.979 49.4454 51.6985 49.6118C52.418 49.7783 53.1657 49.7897 53.8901 49.6453C55.4852 49.3451 56.8304 48.5839 58.1231 47.5832Z"
                          fill="transparent"
                        ></path>
                        <path
                          d="M58.1229 47.5832C56.8301 48.5687 55.4849 49.345 53.9022 49.6483C53.1778 49.7927 52.4301 49.7813 51.7106 49.6148C50.9911 49.4484 50.3168 49.1308 49.734 48.6839C49.6044 48.593 49.4779 48.4959 49.3483 48.4019C49.3373 48.3982 49.3254 48.3982 49.3144 48.4019C48.8547 48.6839 48.4196 49.0084 47.9414 49.2328C46.5592 49.9181 45.1369 49.8848 43.6991 49.3996C42.5292 48.983 41.4469 48.3591 40.5059 47.5589C40.6 47.5767 40.6928 47.6011 40.7835 47.6317C42.4558 48.2958 44.0354 48.0653 45.5534 47.1799C46.2291 46.7826 46.8986 46.3763 47.5866 46.0094C47.8155 45.8796 48.0704 45.8003 48.3337 45.7773C48.5969 45.7543 48.8621 45.7879 49.1107 45.876C49.2198 45.9122 49.338 45.9122 49.447 45.876C49.7552 45.7767 50.0826 45.7486 50.4036 45.7938C50.7247 45.839 51.0308 45.9564 51.2982 46.1367C52.0356 46.5461 52.7483 46.9888 53.4888 47.3861C54.1455 47.75 54.8787 47.9604 55.6315 48.0009C56.3843 48.0414 57.1365 47.9109 57.8298 47.6196C57.8976 47.5923 57.9686 47.5741 58.0365 47.5529C58.0365 47.5468 58.0519 47.5589 58.1229 47.5832Z"
                          fill="#216fc8"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_26_398">
                          <rect
                            width="39.0011"
                            height="75.3125"
                            fill="transparent"
                            transform="translate(29.998 12.3438)"
                          ></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div
                    className="content text-center"
                    style={{ fontFamily: "Aharoni" }}
                  >
                    <h2
                      className="m-0 fw-bold text-white"
                      style={{ fontSize: 50, lineHeight: "40px" }}
                    >
                      StarPilot
                    </h2>
                    <h5 className="m-0 text-white">Concierge</h5>
                  </div>
                </div>
                <div className=" pt-2">
                  <div className="row justify-content-center">
                    {attendeeItems}
                  </div>
                </div>
                {videoTiles && (
                  <>
                    <div className="members-dv">
                      {tileId && <p>Active Id now: {tileId}</p>}
                      <div className="row justify-content-center">
                        <div className="col-md-6 col-lg-3 col-xl-2 col-6">
                          <div className="member-image">
                            <LocalVideo nameplate="me" id="localvideo" />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3 col-xl-2 col-6">
                          <div className="member-image">
                            {tiles.map((item) => {
                              const attendee = tileIdToAttendeeId[item];

                              let remotename = "";

                              if (roster[attendee]) {
                                const { externalUserId } = roster[attendee];
                                remotename = externalUserId.split("#")[1];
                              }
                              return (
                                <>
                                  <RemoteVideo
                                    tileId={item}
                                    id={`remote_${item}`}
                                    className="remotevideo"
                                  />
                                  <span>user: {remotename}</span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      <div
                        className={`${
                          !sharingAttendeeId && "col-lg-3 col-xl-2"
                        } col-md-12 `}
                      >
                        <div className="member-joined bg-dark">
                          <div
                            className="member1 h-auto"
                            style={{ aspectRatio: 1 }}
                          >
                            {isLocalUserSharing ? (
                              <p>{activeSpeakerName}</p>
                            ) : (
                              <ContentShare />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {meetingResponse?.Meeting?.MeetingId &&
                parseInt(localStorage.getItem("user_login_type_role")) != 1 && (
                  <StarpilotChat
                    invite={invite}
                    patientName={patientName}
                    setPatientName={setPatientName}
                    setInvite={setInvite}
                    guest={guest}
                    addMonteChatTranscript={add_montechat_transcript}
                    transacriptName={transacriptName}
                    buttonClick={buttonClick}
                    videoTiles={videoTiles}
                    conversation={conversation}
                    setConversation={setConversation}
                    screenShareBtn={screenShareBtn}
                    handleScreenShare={handleScreenShare}
                    handleScreenShareBtn={handleScreenShareBtn}
                    videoBtn={videoBtn}
                    showIsNameModal={showIsNameModal}
                    audible={audible}
                    setAudible={setAudible}
                    loadingChat={loadingChat}
                    setLoadingChat={setLoadingChat}
                    setShowIsNameModal={setShowIsNameModal}
                    handleOtherUserJoin={handleOtherUserJoin}
                    leaveMeeting={leaveMeeting}
                    leaveBtn={leaveBtn}
                    autoPrescMain={autoPresc}
                    audioStatus={audioStatus}
                    handleAudio={handleAudio}
                    callCreated={callCreated}
                    language={language}
                    setLanguage={setLanguage}
                    speak={speak}
                    cancel={cancel}
                    speaking={speaking}
                    supported={supported}
                    voices={voices}
                    speakingText={speakingText}
                    setSpeakingText={setSpeakingText}
                    translatedText={translatedText}
                    patientLanguage={patientLanguage}
                    activeChat={activeChat}
                    setActiveChat={setActiveChat}
                    setPatientLanguage={setPatientLanguage}
                    resetTranscript={resetTranscript}
                    meetingid={
                      data?.meeting_id
                        ? data?.meeting_id
                        : param.meetingid
                        ? param.meetingid
                        : meetingResponse?.Meeting?.MeetingId
                    }
                    chat={chat}
                    setChat={setChat}
                    invitedId={param.appointmentid}
                  />
                )}
            </div>
          </section>
        </main>
        <Footer />
      </main>

      {showSuggestionModal && (
        <>
          <div
            className={`modal fade ${showSuggestionModal ? "show" : ""}`}
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            style={{ display: showSuggestionModal ? "block" : "none" }}
          >
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
              <div className="modal-content ">
                <div className="modal-header border-0">
                  <div className="d-flex align-items-center justify-content-between meeting-widgets">
                    <h1
                      className="modal-title font_600 fs-5"
                      id="staticBackdropLabel"
                    >
                      Suggestion
                    </h1>
                    <div onClick={handleDownloadTxtFile} className="join-other">
                      <i class="fa-solid fa-download"></i>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={closeSuggestionModal}
                  />
                </div>
                <div className="modal-body modal-overflow">
                  <pre className="mb-2 text-justify white-space-pre">
                    {getChatGptResponse}
                  </pre>
                </div>
                <div className="d-flex p-3">
                  <input
                    type="text"
                    id="user-input"
                    className="form-control"
                    placeholder="Type your message..."
                    value={inputText}
                    autoComplete="off"
                    onChange={(e) => setInputText(e.target.value)}
                  />

                  {handleLoader ? (
                    <button className="chatbutton flex-1">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </button>
                  ) : (
                    <button
                      className="chatbutton flex-1"
                      onClick={handleSendMessage}
                      disabled={inputText === ""}
                    >
                      <i className="fa-solid fa-paper-plane"></i>
                    </button>
                  )}

                  <label
                    htmlFor="fileInput"
                    className="filebutton flex-1 fa-solid fa-file-arrow-up"
                  >
                    <input
                      id="fileInput"
                      ref={fileInputRef}
                      type="file"
                      className="d-none"
                      onChange={onImageChange}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

const LabelTag = styled.div`
  right: 0;
  @media (max-width: 575px) {
    bottom: 0;
  }
`;

export default MeetingRoomSingleMic;
